import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import clsx from 'clsx';
import './value-label-badge.scss';

/**
 * Value Label Badge: holds two related pieces of data.
 *
 * - base badge style
 * - very little default styling
 * - can be customised through className / `scss`
 */
export default function ValueLabelBadge({
  label,
  value,
  color,
  pill,
  className
}: {
  label: ReactNode;
  value: ReactNode;
  color?: string;
  pill?: boolean;
  className?: string;
}): ReactElement {
  return (
    <div
      className={clsx('badge', 'value-label-badge', pill, className, {
        [`bg-${color}`]: color
      })}
    >
      <span className="badge-label">{label}</span>
      <span className="badge-value">{value}</span>
    </div>
  );
}
